function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsxs as r, jsx as e } from "react/jsx-runtime";
import { useTheme as n } from "../../hooks.js";
import { useIsInverseVariant as s } from "../../theme-variant-context.js";
import { vars as i } from "../../skins/skin-contract.css-mistica.js";
const m = (_param)=>{
    var { color: c , size: t = 24  } = _param, l = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const h = s(), a = c !== null && c !== void 0 ? c : h ? i.colors.inverse : i.colors.neutralHigh, { skinName: o  } = n();
    return o.match(/^vivo-new/i) ? /* @__PURE__ */ r("svg", _object_spread_props(_object_spread({
        width: t,
        height: t,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, l), {
        children: [
            /* @__PURE__ */ e("path", {
                fill: a,
                d: "M11.35 9.566a.425.425 0 01.85 0v4.65a.425.425 0 01-.85 0v-4.65zm.425 7.165a.425.425 0 100-.85.425.425 0 000 .85z"
            }),
            /* @__PURE__ */ e("path", {
                fill: a,
                d: "M13.463 4.14c-.646-1.134-2.28-1.134-2.927 0L2.533 18.195a1.684 1.684 0 001.463 2.517h16.007a1.684 1.684 0 001.463-2.517L13.463 4.14zm7.264 14.475a.834.834 0 01-.724 1.246H3.996a.834.834 0 01-.724-1.247l8.003-14.053a.834.834 0 011.45 0l8.002 14.053z"
            })
        ]
    })) : o.match(/^o2/i) ? /* @__PURE__ */ e("svg", _object_spread_props(_object_spread({
        width: t,
        height: t,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, l), {
        children: /* @__PURE__ */ e("path", {
            fill: a,
            d: "M12.011 4.1L3.02 20.267h18.625c.214 0 .356.146.356.367s-.142.367-.356.367H2.374a.432.432 0 01-.32-.183.334.334 0 010-.367l9.638-17.267a.372.372 0 01.32-.183.38.38 0 01.32.183l7.133 12.789c.073.184.037.405-.141.513-.179.075-.393.037-.498-.146L12.01 4.1zm.357 4.408c0-.221-.142-.367-.357-.367-.214 0-.356.146-.356.367v7.902c0 .22.142.366.356.366.215 0 .357-.145.357-.366V8.508zm7.92 10.512c.392 0 .712-.33.712-.734a.724.724 0 00-.713-.734.724.724 0 00-.712.734c0 .405.324.734.712.734zm-8.277-.038c-.283 0-.534-.258-.534-.55a.53.53 0 01.534-.55c.284 0 .535.258.535.55 0 .292-.251.55-.535.55z"
        })
    })) : /* @__PURE__ */ r("svg", _object_spread_props(_object_spread({
        width: t,
        height: t,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, l), {
        children: [
            /* @__PURE__ */ e("path", {
                fill: a,
                d: "M12.025 17.517a.314.314 0 01-.314-.313V8.03a.314.314 0 01.628 0v9.174a.312.312 0 01-.314.313zm-.022 2.469c-.216 0-.339-.125-.339-.338 0-.213.126-.339.34-.339.212 0 .338.126.338.339 0 .213-.122.338-.339.338z"
            }),
            /* @__PURE__ */ e("path", {
                fill: a,
                d: "M22.496 23H1.507a.499.499 0 01-.44-.226.499.499 0 01-.005-.492l10.53-21C11.68 1.103 11.831 1 12 1c.17 0 .32.103.41.282l10.528 21a.499.499 0 01-.006.492c-.085.145-.245.226-.436.226zm-20.82-.602h20.648L12.004 1.805 1.675 22.398z"
            })
        ]
    }));
}, g = m;
export { g as default };
